import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Textarea } from '../../ui/textarea';
import { pulizieApi, erroreApi } from './api';

const AZIONI = ['Ripetuta la pulizia', 'Chiamato il tecnico', 'Usato un altro prodotto', 'Avvisato il responsabile'];

export const ProblemaDialog = ({ zona, operatore, onClose, onSaved }) => {
  const [problema, setProblema] = useState('');
  const [azione, setAzione] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => { setProblema(''); setAzione(''); }, [zona]);

  const salva = async () => {
    setBusy(true);
    try {
      await pulizieApi.post('/problema', { zona, problema, azione, operatore });
      toast.success(`${zona}: problema registrato`);
      onSaved();
    } catch (e) {
      toast.error(erroreApi(e, 'Non sono riuscito a salvare'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!zona} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="pulizie-problema-dialog">
        <DialogHeader>
          <DialogTitle>Problema in {zona}</DialogTitle>
          <DialogDescription>Va scritto cosa non andava e cosa hai fatto per risolverlo.</DialogDescription>
        </DialogHeader>
        <label className="text-sm font-medium">Cosa non va?</label>
        <Textarea value={problema} onChange={(e) => setProblema(e.target.value)} rows={2}
          placeholder="Es. lavastoviglie guasta, detergente finito" data-testid="pulizie-problema-testo" />
        <label className="text-sm font-medium">Cosa hai fatto?</label>
        <div className="flex flex-wrap gap-2">
          {AZIONI.map((a) => (
            <button key={a} onClick={() => setAzione(a)} data-testid={`pulizie-azione-${a.split(' ')[0].toLowerCase()}`}
              className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${azione === a ? 'bg-amber-500 border-amber-500 text-white' : 'border-gray-300 hover:bg-gray-100'}`}>
              {a}
            </button>
          ))}
        </div>
        <Textarea value={azione} onChange={(e) => setAzione(e.target.value)} rows={2}
          placeholder="Es. stoviglie lavate a mano a 60 gradi" data-testid="pulizie-problema-azione" />
        <Button onClick={salva} disabled={busy || problema.trim().length < 3 || azione.trim().length < 3}
          className="h-11 bg-amber-500 hover:bg-amber-600 text-white" data-testid="pulizie-problema-salva">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Registra il problema'}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
